var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinTeal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#018D96;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "linkedin-3",
    className: "st0",
    d: "M809.9,3.3H190.1C86.9,3.3,3.3,86.9,3.3,190.1l0,0V810c0,103.2,83.6,186.8,186.8,186.8l0,0H810 c103.2,0,186.8-83.6,186.8-186.8l0,0V190.1C996.7,86.9,913.1,3.3,809.9,3.3L809.9,3.3z M334.4,789.8H210.2V334.4h124.2V789.8z  M272.4,281.9c-40.3,0.3-73.3-32.1-73.6-72.4s32.1-73.3,72.4-73.6s73.3,32.1,73.6,72.4c0,0.2,0,0.4,0,0.6 C344.9,249.1,312.5,281.8,272.4,281.9L272.4,281.9z M831.2,789.8H707v-232c0-139.5-165.6-128.9-165.6,0v231.9H417.3V334.4h124.2 v73.1C599.3,300.4,831.2,292.6,831.2,510V789.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinTeal);
export default __webpack_public_path__ + "static/media/linkedin-teal.ce434b87bd756fae774c30c32fe413c4.svg";
export { ForwardRef as ReactComponent };